import React, { useMemo } from "react";
import { useQuery } from "react-query";
import { Card, Typography, Spin, Empty, Row, Col } from "antd";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { getPlansWithDefault } from "../../../services/dashboard.service";
import { MoreOutlined } from "@ant-design/icons";
import { formatCurrency } from "../../../services/utils";

const { Title, Text } = Typography;

const COLORS = [
  "#FF8042",
  "#FFBB28",
  "#00C49F",
  "#0088FE",
  "#8884d8",
  "#82ca9d",
];

export default function PlansWithDefault() {
  const { data, isLoading } = useQuery(
    "getPlansWithDefault",
    getPlansWithDefault,
    {
      refetchOnWindowFocus: false,
    }
  );

  const { chartData, totalPlans } = useMemo(() => {
    const rawData = data?.data || [];

    // Calculate total revenue by summing up 'total' fields
    const total = rawData.reduce(
      (acc: number, curr: any) => acc + parseFloat(curr.count || 0),
      0
    );

    // Map data for Recharts (needs 'value' key)
    const mappedData = rawData.map((item: any) => ({
      name: item.name,
      value: parseFloat(item.count),
    }));

    return { chartData: mappedData, totalPlans: total };
  }, [data]);

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Title level={5} style={{ margin: 0 }}>
              Inadimplência por Plano Contratado
            </Title>
          </div>
        </div>
      }
      bordered={false}
      style={{ height: "100%" }}
    >
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
          <Spin />
        </div>
      ) : chartData.length > 0 ? (
        <Row gutter={16} align="middle">
          <Col span={24} style={{ marginBottom: 16 }}>
            <Title level={2} style={{ margin: 0 }}>
              {totalPlans}
            </Title>
            <Text type="secondary">
              planos contratados com parcelas inadimplentes
            </Text>
          </Col>
          <Col span={24}>
            <div style={{ width: "100%", height: 300 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={80}
                    fill="#8884d8"
                    paddingAngle={5}
                    dataKey="value"
                    nameKey="name"
                  >
                    {chartData.map((entry: any, index: number) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </Col>
        </Row>
      ) : (
        <Empty description="Sem dados" />
      )}
    </Card>
  );
}
